import  { usersLogin, getStudentInfo, getNocUserInfo } from '@/services/user';
import { getNocInfo, getToken, getExamList } from '@/services/noc';
import { router } from '@/router';
import { getURLParams } from '@/utils/query-string';
import XEventSource from '@/utils/x-eventsource';
import Vue from 'vue'

const user = {
  state: {
    userInfo: {},
    autoLoginInfo: {},
    regInfo: {},
    tokenID: getURLParams('id'),
    bgImg:'',
    isShowSend: false,
    isInsidSignUp:false,
    isUserDiaLog:{
      isShowDiaLog:false,
      currentVal:'login'
    },
    refreshState:{
      type:'',
      flag:false
    },
    isRegDiaLog:false,
    isNoticeState:false,
    isSerialDiaLog:false, //序列赛注册弹窗
    serialType:'1', // 序列赛=> 1注册 2报名
    currentUserInfo: {}, // 报名信息
    compInfo: {}, //赛项信息
    userEntry: {},
    modifyStatus: false,
    activeIndex: 1,
    menuData: {},
    nocInfo: {},
    yuanquanToken: '',
    examList: [],
  },
  
  getters: {
    loginStatus(state) {
      return (
        state.userInfo && !!state.userInfo.compCode
      );
    },
    // 初赛结果是否出来
    isPreliminaryResult(state) {
      return state.userInfo && state.userInfo.preliminaryContestPromoted !== ''
    },
    // 初赛晋级状态
    isPreliminary(state) {
      return state.userInfo && state.userInfo.preliminaryContestPromoted === '晋级'
    },
    // 复赛结果是否出来
    isIntermediaryResult(state) {
      return state.userInfo && state.userInfo.intermediaryHeatPromoted !== ''
    },
    // 复赛晋级状态
    isIntermediary(state) {
      return state.userInfo && state.userInfo.intermediaryHeatPromoted === '晋级'
    },
    // 当前所处的阶段
    currentStage(state) {
      if (state.userInfo && state.userInfo.intermediaryHeatPromoted === '晋级') {
        return '决赛'
      }
      if (state.userInfo && state.userInfo.preliminaryContestPromoted === '晋级') {
        return '复赛'
      }
      return '初赛'
    },
    // 根据 language 和 group 筛选出当前登录人所处的配置信息
    currentCompInfo(state) {
      const { language, group } = state.userInfo
      const { language: languageArray } = state.nocInfo
      if (!language || !group || !languageArray) return {}
      let compInfo = {}
      languageArray.some((item) => {
        if (item.name === language) {
          item.groups.some((_group) => {
            if (_group.name === group) {
              compInfo = _group
              return true
            }
            return false
          })
        }
      })
      return compInfo
    },
    // 根据 currentCompInfo 和 currentStage 筛选出当前登录人的比赛时间
    currentCompTime(state, getters) {
      const { currentCompInfo, currentStage } = getters
      if (currentStage === '初赛') return currentCompInfo.timeFirst
      if (currentStage === '复赛') return currentCompInfo.timeSecond
      if (currentStage === '决赛') return currentCompInfo.timeThird
      return '待定'
    },
  },
 
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_AUTO_LOGIN_INFO(state, userInfo) {
      state.autoLoginInfo = userInfo
      if (userInfo.accessToken) state.userInfo.accessToken = userInfo.accessToken
    },
    SET_NOC_INFO(state, data) {
      state.nocInfo = data
    },
    SET_YUANQUAN_TOKEN(state, token) {
      state.yuanquanToken = token
    },
    SET_EXAM_LIST(state, list) {
      state.examList = list
    },
    REG_INFO(state, payload) {
      state.regInfo = payload
    },
    SAVE_BGURL(state, payload) {
      state.bgImg = payload
    },
    SET_SEND(state, payload) {
      state.isShowSend = payload;
    },
    AET_INSID_SIGN_Up(state, payload) {
      state.isInsidSignUp = payload
    },
    SET_USER_DIA_LOG(state, payload){
      state.isUserDiaLog = {...state.isUserDiaLog,...payload}
    },
    SET_REFRESH(state, payload){
      state.refreshState = payload
    },
    SET_REG_DIA_LOG(state, payload){
      state.isRegDiaLog = payload
    },
    SET_NOTICE_STATE(state,payload){
      state.isNoticeState = payload
    },
    SET_IS_SERIESDIALOG(state,playload){
      state.isSerialDiaLog = playload;
    },
    SET_SERIAL_TYPE(state,playload){
      state.serialType = playload;
    },
    SET_CURRENT_USER_INFO(state,playload){
      state.currentUserInfo = playload;
    },
    SET_COMP_INFO(state, playload) {
      state.compInfo = playload
    },
    USER_ENTRY(state, playload) {
      state.userEntry = playload
    },
    SET_MODIFY_STATUS(state,playload){
      state.modifyStatus = playload;
    },
    SET_ACTIVE_INDEX(state,playload){
      state.activeIndex = playload
    },
    SET_USER_NAME(state,playload){
      Vue.set(state.userInfo, 'username', playload)
    },
    setMenuData(state,playload){
      Vue.set(state.menuData, playload.id, playload.value)
    },
  },

  actions: {
    initUserInfo({state, dispatch, rootGetters }) {
      const {xilieTokenKey} = rootGetters;
      // const {isSerial} = rootState.router;
        let data;
        if(!state.tokenID) {
          data = JSON.parse(sessionStorage.getItem(xilieTokenKey+'_2024')) || {};
        } else {
          data = JSON.parse(sessionStorage.getItem(`${xilieTokenKey}_${state.tokenID}`)) || {};
        }
        dispatch('saveUserInfo',data);
    },
    saveUserInfo({state, commit, rootGetters }, params) {
      commit("SET_USER_INFO", params)
      //NOCToken需要加上id且有token时才存
      if(state.tokenID&&Object.keys(params).length>0) {
        return sessionStorage.setItem(`${rootGetters.xilieTokenKey}_${state.tokenID}`, JSON.stringify(params))
      }
      if(!state.tokenID&&Object.keys(params).length>0) {
        return sessionStorage.setItem(rootGetters.xilieTokenKey+'_2024', JSON.stringify(params))
      }
      return sessionStorage.setItem(rootGetters.xilieTokenKey, JSON.stringify(params))
    },
    saveAutoLoginInfo({ commit }, payload) {
      commit("SET_AUTO_LOGIN_INFO", payload)
    },
    setUserName({ commit,dispatch,state }, payload){
      commit('SET_USER_NAME', payload)

      dispatch('saveUserInfo',state.userInfo);
    },
    saveRegInfo({ commit }, payload) {
      commit('REG_INFO', payload)
    },
    // 登录
    async Login({ commit, rootGetters }, paramms) {
      const res = await usersLogin(paramms)
      commit("SET_USER_INFO", res.data)
      return sessionStorage.setItem(rootGetters.xilieTokenKey, JSON.stringify(res.data))
      // if(rootState.router.isSerial || !rootState.router.id) {
      //   return sessionStorage.setItem(rootGetters.xilieTokenKey, JSON.stringify(res.data))
      // }
      // sessionStorage.setItem(rootGetters.tokenKey, JSON.stringify(res.data))
    },

    nocLogOut({state, commit, rootGetters}){
      commit('SET_USER_INFO', {});
      commit('AET_INSID_SIGN_Up',false)
      commit('SET_SERIAL_TYPE','1')
      sessionStorage.removeItem(rootGetters.xilieTokenKey)
      if (state.tokenID) {
        sessionStorage.removeItem(`${rootGetters.xilieTokenKey}_${state.tokenID}`)
      } else {
        sessionStorage.removeItem(`${rootGetters.xilieTokenKey}_2024`)
      }
      // sessionStorage.removeItem(rootGetters.tokenKey)
    },
    // 登出
    LogOut({ dispatch }) {
      dispatch('nocLogOut')
      const id = getURLParams('id')
      const params = {}
      if (id) params.id = id
      router.replace({
        path: '/login',
        query: params
      })
    },
    setSmsSend({
      commit
    }, payload) {
      commit('SET_SEND', payload)
    },
    // 内部竞赛报名成功
    setInsidSignUp({
        commit,
      }, payload) {
      commit('AET_INSID_SIGN_Up', payload);
    },
    setUserDiaLog({commit},payload){
      commit('SET_USER_DIA_LOG', payload);
    },
    setRefresh({commit},payload){
      commit('SET_REFRESH', payload);
    },
    setRegDiaLog({commit},payload){
      commit('SET_REG_DIA_LOG', payload);
    },
    setNoticeState({commit},payload){
      commit('SET_NOTICE_STATE',payload)
    },
    golbalNotice({state,dispatch},competitionId){
      if(xeventsource) xeventsource.abort();
      let xeventsource = null;
      xeventsource = new XEventSource(`${process.env.VUE_APP_URL}/api/competition/sse/stu/update/${competitionId}/`);
      xeventsource.on('message', (resp) => {
        try {
          let data = JSON.parse(resp.data);
          if (data) {
            if(!state.isNoticeState) dispatch('setNoticeState',true)
            xeventsource.destroy();
            return;
          }
        } catch (err) {
          dispatch('setNoticeState',false)
          xeventsource.abort();
        }
      })
      xeventsource.on('close', () => {
        xeventsource.abort();
        dispatch('setNoticeState',false)
      });
      xeventsource.on('error', () => {
        xeventsource.destroy();
        dispatch('setNoticeState',false)
      });
    },
    setIsSerialDiaLog({commit},payload){
      commit('SET_IS_SERIESDIALOG',payload)
    },
    setSerialType({commit},payload){
      commit('SET_SERIAL_TYPE',payload)
    },
    async getStudentInfo({commit},id) {
      getStudentInfo(id).then(res=>{
        const {data, status} = res
        if (status === 200) {
          commit('SET_CURRENT_USER_INFO', data || {})
        }
      })
    },
    setModifyStatus({commit},payload){
      commit('SET_MODIFY_STATUS',payload)
    },
    setActiveIndex({commit},index){
      commit('SET_ACTIVE_INDEX', index)
    },
   async getStudentNocInfo({state,dispatch}) {
      const data = await getNocUserInfo({
        compCode: state.userInfo.compCode,
        competitorOne: state.userInfo.competitorOne,
      })
      if(data.status === 200) {
        dispatch('saveUserInfo', data.data || {})
      }
    },
    async getNocInfo({commit,state}, payload) {
      const data = await getNocInfo(payload)
      if (JSON.stringify(data) === JSON.stringify(state.nocInfo)) return
      commit('SET_NOC_INFO', data || {})
    },
    async getYuanquanToken({commit}) {
      const data = await getToken()
      if(data.status_code === 200) {
        commit('SET_YUANQUAN_TOKEN', data.data.access_token || '')
      }
    },
    async getExamList({commit, state}) {
      const data = await getExamList(state.yuanquanToken)
      if(data.status_code === 200) {
        commit('SET_EXAM_LIST', data.data.list || [])
      } else {
        Vue.prototype.$message.showMessage({ info: data.message })
      }
    }
  },
  
}

export default user
